import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function PartnerSelectModal({ title, onClose, handlePartnerClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    partner_name: true,
    partner_type: false,
    partner_type_name: true,
    partner_number: true,
    partner_corp_number: true,
    partner_ceo: true,
    partner_ceo_phone: false,
    partner_ceo_email: false
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    searchRef.current.focus();
    handleView();

    setColumnVisibilityModel({
      id: false,
      partner_name: true,
      partner_type: false,
      partner_type_name: true,
      partner_number: true,
      partner_corp_number: true,
      partner_ceo: true,
      partner_ceo_phone: false,
      partner_ceo_email: false
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
        { field: 'id', headerName: 'partner_id', width: 0, headerAlign: 'center' },
        { field: 'partner_name', headerName: '거래처명', width: 190, headerAlign: 'center' },
        { field: 'partner_type', headerName: 'partner_type', width: 0, headerAlign: 'center' },
        { field: 'partner_type_name', headerName: '유형', width: 100, headerAlign: 'center', align:'center' },
        { field: 'partner_number', headerName: '사업자번호', width: 130, headerAlign: 'center', align:'center' },
        { field: 'partner_corp_number', headerName: '법인코드', width: 150, headerAlign: 'center', align:'center' },
        { field: 'partner_ceo', headerName: '대표자', width: 100, headerAlign: 'center', align:'center' },
        { field: 'partner_ceo_phone', headerName: ' 휴대폰번호', width: 150, headerAlign: 'center', align:'center' },
        { field: 'partner_ceo_email', headerName: 'E-Mail', width: 150, headerAlign: 'center', align:'center' },
    ]);
  }

  const handleView = () => {
    axios.get('/api/SelectCommon/PartnerList',
        {
        params : {
          keyword: keyword
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
        
        var array = response.data.map((item, index) => ({
            id: item.partner_id,
            partner_name: item.partner_name,
            partner_type: item.partner_type,
            partner_type_name: item.partner_type_name,
            partner_number: item.partner_number,
            partner_corp_number: item.partner_corp_number,
            partner_ceo: item.partner_ceo,
            partner_ceo_phone: item.partner_ceo_phone,
            partner_ceo_email: item.partner_ceo_email
        }));
        setRows(array);
        
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    //부모로 연결된 클릭 이벤트 부모에 handlePartnerClick 이벤트 만들어 놓아야함.
    handlePartnerClick(params.row);
    onClose?.();
  };

  const handleDelete = () => {
    handlePartnerClick({
      id : '',
      partner_name: '',
      partner_type: '',
      partner_type_name: '',
      partner_number: '',
      partner_corp_number: '',
      partner_ceo: '',
      partner_ceo_phone: '',
      partner_ceo_email: ''
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default PartnerSelectModal;